export default __webpack_public_path__ + "static/media/deliveries_6.486f9e23.png";